import { motion } from "framer-motion";

const ease = [0.2, 0.7, 0.2, 1];

export function Reveal({ children, delay = 0, y = 28, className = "", as = "div" }) {
  const C = motion[as] || motion.div;
  return (
    <C className={className} initial={{ opacity: 0, y }} whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.12 }} transition={{ duration: 0.9, delay, ease }}>
      {children}
    </C>
  );
}

export function MaskLines({ lines, className = "", lineClass = "", delay = 0.15, stagger = 0.12 }) {
  return (
    <span className={className}>
      {lines.map((l, i) => (
        <span key={i} className="block overflow-hidden pb-[0.08em]">
          <motion.span className={`block ${lineClass}`} initial={{ y: "105%" }} animate={{ y: "0%" }}
            transition={{ duration: 1.1, delay: delay + i * stagger, ease }}>
            {l}
          </motion.span>
        </span>
      ))}
    </span>
  );
}

export function SectionHead({ eyebrow, title, action, testid }) {
  return (
    <div className="flex items-end justify-between gap-6 border-t border-[var(--ink)] pt-5 mb-10" data-testid={testid}>
      <div>
        <p className="eyebrow mb-3">{eyebrow}</p>
        <h2 className="f-serif text-3xl sm:text-4xl lg:text-5xl tracking-tight leading-[1.02]">{title}</h2>
      </div>
      {action}
    </div>
  );
}
